import React from 'react';

export const CarfaxBadge = ({ v, en, className = 'h-8', testid }) => {
  const img = (en && v.carfax_badge_img_en) || v.carfax_badge_img;
  const url = (en && v.carfax_report_url_en) || v.carfax_report_url;
  if (!img) return null;
  const badge = <img src={img} alt={en ? 'CARFAX Canada vehicle history' : 'Historique CARFAX Canada'} className={`${className} w-auto`} loading="lazy" />;
  if (!url) return <span data-testid={testid}>{badge}</span>;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="inline-block hover:opacity-80 transition-opacity"
      data-testid={testid}
    >
      {badge}
    </a>
  );
};
